import { render, staticRenderFns } from "./DealFollowers.vue?vue&type=template&id=7d3cc0ba&"
import script from "./DealFollowers.vue?vue&type=script&lang=js&"
export * from "./DealFollowers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports